import { IScope, ITimeoutService, IWindowService, noop } from "angular";
import { format, parse, parseISO, parseJSON } from "date-fns";
import * as $ from "jquery";
import datepickerFactory from "jquery-datepicker";
import { BlockConfigurationObject } from "../../interfaces/block-configuration-object.interface";
import { FixtureRound } from "../../interfaces/fixture-round.interface";
import { Match } from "../../interfaces/match.interface";
import { TennisTournament } from "../../interfaces/tennis-tournament.interface";
import { BetService } from "../../services/bet.service";
import { GeneralService } from "../../services/general.service";
import { MatchService } from "../../services/match.service";
import { SportDataService } from "../../services/sport-data.service";

export class MatchListController {

	betService: BetService;
	bookOptions: Array<string> = [];
	configurationObject: BlockConfigurationObject;
	currentRound = null;
	currentTournament: TennisTournament = null;
	dateDropdownOpen = false;
	displayMode = "full";
	euroRoundMap = [
		"",
		"Group Matchday 1",
		"Group Matchday 2",
		"Group Matchday 3",
		"Round of 16",
		"Quarter Finals",
		"Semi Finals",
		"Final"
	]
	swcRoundMap = [
		"Qualifying Play-Offs",
		"Group Matchday 1",
		"Group Matchday 2",
		"Group Matchday 3",
		"Round of 16",
		"Quarter Finals",
		"Semi Finals",
		"Third-Place Play-Off",
		"Final"
	];
	fixtureSearch = "";
	gamesError = false;
	gamesLoading = true;
	generalService: GeneralService;
	matches = [];
	matchListSport = "";
	matchService: MatchService;
	noTournamentsActive = false;
	roundDropdownOpen = false;
	roundOptions: Array<FixtureRound> = [];
	roundsError = false;
	roundsLoaded = false;
	seasonDropdownOpen = false;
	seasonOptions = [];
	sportDataService: SportDataService;
	tournamentDropdownOpen = false;
	tournamentOptions = [];
	updateTimeout = null;

	_$scope: IScope;
	// _Rollbar: any;
	_$window: IWindowService;
	_$timeout: ITimeoutService
	

	displayMaximumWidths = {
		"x-compact": 350,
		"compact": 500,
		"less-compact": 600,
		"medium": 700,
		"large": 800,
		"x-large": 1000,
	};

	/* @ngInject */
	constructor($scope: IScope, /*Rollbar: any,*/ $window: IWindowService, $timeout: ITimeoutService, configurationObject: BlockConfigurationObject, matchService: MatchService, sportDataService: SportDataService, generalService: GeneralService, betService: BetService, public cdnDomain: string) {
		
		this._$scope = $scope;
		// this._Rollbar = Rollbar;
		this._$window = $window;
		this._$timeout = $timeout;
		this.configurationObject = configurationObject;
		this.matchService = matchService;
		this.sportDataService = sportDataService;
		this.generalService = generalService;
		this.betService = betService;

		this.bookOptions = configurationObject.bookmakers;
		this.matchListSport = configurationObject.sportCode.toUpperCase();
		generalService.initialiseBlock();
		Object.keys(this.displayMaximumWidths).forEach(level => {
			if ($window.document.getElementById(configurationObject.targetElementID) && $window.document.getElementById(configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				this.displayMode += ` ${level}`;
			}
		});

		datepickerFactory($);
	
		$window.addEventListener("resize", this.checkCompact);
		
		document.addEventListener("click", event => {
			if ((event.target as Element).closest(".date-dropdown") === null && (event.target as Element).closest("[class*=ui-datepicker]") === null) {
				$scope.$apply(() => {
					this.dateDropdownOpen = false;
				});
			}
			
			if ((event.target as Element).closest(".season-dropdown") === null) {
				$scope.$apply(() => {
					this.seasonDropdownOpen = false;
				});
			}
	
			if ((event.target as Element).closest(".round-dropdown") === null) {
				$scope.$apply(() => {
					this.roundDropdownOpen = false;
				});
			}

			if ((event.target as Element).closest(".tournament-dropdown") === null) {
				$scope.$apply(() => {
					this.tournamentDropdownOpen = false;
				});
			}
		});
		
		matchService.getGeoData().then(() => {
			if (this.matchListSport.toUpperCase() === "TEN") {
				new Promise((res,rej) => this.getTournamentOptions(res,rej)).then(() => {
					$scope.$apply(() => {
						this.roundsLoaded = true;
					});
					if (!this.noTournamentsActive) {
						new Promise((res,rej) => this.retrieveGames(res,rej)).then(noop, () => {
							$scope.$apply(() => {
								this.gamesError = true;
							});
						});
					}
					
				}, () => {
					$scope.$apply(() => {
						this.roundsError = true;
					});
				});
			} else {
				new Promise((res,rej) => this.getRoundOptions(res,rej)).then(() => {
					$scope.$apply(() => {
						this.roundsLoaded = true;
					});
					new Promise((res,rej) => this.retrieveGames(res,rej)).then(noop, () => {
						$scope.$apply(() => {
							this.gamesError = true;
						});
					});
				}, () => {
					$scope.$apply(() => {
						this.roundsError = true;
					});
				});
			}
			

		}, () => {
			if (this.matchListSport.toUpperCase() === "TEN") {
				new Promise((res,rej) => this.getTournamentOptions(res,rej)).then(() => {
					$scope.$apply(() => {
						this.roundsLoaded = true;
					});
					if (!this.noTournamentsActive) {
						new Promise((res,rej) => this.retrieveGames(res,rej)).then(noop, () => {
							$scope.$apply(() => {
								this.gamesError = true;
							});
						});
					}
					
				}, () => {
					$scope.$apply(() => {
						this.roundsError = true;
					});
				});
			} else {
				new Promise((res,rej) => this.getRoundOptions(res,rej)).then(() => {
					$scope.$apply(() => {
						this.roundsLoaded = true;
					});
					new Promise((res,rej) => this.retrieveGames(res,rej)).then(noop, () => {
						$scope.$apply(() => {
							this.gamesError = true;
						});
					});
				}, () => {
					$scope.$apply(() => {
						this.roundsError = true;
					});
				});
			}
		});

		this._$scope.$on("destroy", function () {
			if (this.updateTimeout) {
				this._$timeout.cancel(this.updateTimeout);
				this.updateTimeout = null;
			}
		});
		const blockParent = document.getElementById(this.configurationObject.targetElementID).parentNode;
		new MutationObserver(() => {
			if (blockParent.querySelector("#" + this.configurationObject.targetElementID) === null) {
				if (this.updateTimeout) {
					this._$timeout.cancel(this.updateTimeout);
					this.updateTimeout = null;
				}
			}
		}).observe(document.getElementById(this.configurationObject.targetElementID).parentNode, {childList: true, subtree: true});
	}

	
	clearFixtureSearch = (): void => {
		this.fixtureSearch = "";
	}

	currentSeasonRoundOptions = (): FixtureRound[] => {
		return this.currentRound ? this.roundOptions.filter(r => r.Year === this.currentRound.Year) : [];
	}

	toggleDateDropdown = (): void => {
		this.dateDropdownOpen = !this.dateDropdownOpen;
	}
	toggleRoundDropdown = (): void => {
		this.roundDropdownOpen = !this.roundDropdownOpen;
	}
	toggleSeasonDropdown = (): void => {
		this.seasonDropdownOpen = !this.seasonDropdownOpen;
	}
	toggleTournamentDropdown = (): void => {
		this.tournamentDropdownOpen = !this.tournamentDropdownOpen;
	}

	checkCompact = (): void => {
		let modeString = "full";
		Object.keys(this.displayMaximumWidths).forEach(level => {
			if (this._$window.document.getElementById(this.configurationObject.targetElementID) && this._$window.document.getElementById(this.configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				modeString += ` ${level}`;
			}
		});

		this._$scope.$apply(() => {
			this.displayMode = modeString;
		});
	}

	matchFitsSearch = (match: Match): boolean => {
		if (this.gamesLoading || this.gamesError) {
			return false;
		}
		if (this.fixtureSearch == "") {
			return true;
		}
		const tokens: string[] = this.fixtureSearch.toLowerCase().split(" ");

		if (this.matchListSport.toLowerCase() === "ten") {
			return match.MatchData.PlayerData && (tokens.some(t => match.MatchData.PlayerData.player1 && match.MatchData.PlayerData.player1.name.toLowerCase().includes(t))
				|| tokens.some(t => match.MatchData.PlayerData.player2 && match.MatchData.PlayerData.player2.name.toLowerCase().includes(t)));
		}

		return (tokens.some(t => match.MatchData.HomeTeam && match.MatchData.HomeTeam.Abv && match.MatchData.HomeTeam.Abv.toLowerCase().includes(t))
			|| tokens.some(t => match.MatchData.HomeTeam && match.MatchData.HomeTeam.Market && match.MatchData.HomeTeam.Market.toLowerCase().includes(t))
			|| tokens.some(t => match.MatchData.HomeTeam && match.MatchData.HomeTeam.Nickname && match.MatchData.HomeTeam.Nickname.toLowerCase().includes(t))
			|| tokens.some(t => match.MatchData.AwayTeam && match.MatchData.AwayTeam.Abv && match.MatchData.AwayTeam.Abv.toLowerCase().includes(t))
			|| tokens.some(t => match.MatchData.AwayTeam && match.MatchData.AwayTeam.Market && match.MatchData.AwayTeam.Market.toLowerCase().includes(t))
			|| tokens.some(t => match.MatchData.AwayTeam && match.MatchData.AwayTeam.Nickname && match.MatchData.AwayTeam.Nickname.toLowerCase().includes(t)));
		
	}
	
	titleDate = (): string => {
		if (this.currentRound && this.currentRound.Round_Date) {
			return format(parseISO(this.currentRound.Round_Date), this.configurationObject.dateDayBeforeMonth ? "d MMM" : "MMM d");
		}

		return "";
	}

	dropdownDate = (): string => {
		if (this.currentRound && this.currentRound.Round_Date) {
			return format(parseISO(this.currentRound.Round_Date), this.configurationObject.dateDayBeforeMonth ? "d MMM yyyy" : "MMM d yyyy");
		}

		return "";
	}

	goToRound = (year: number, roundNo: number): void => {
		if (roundNo === -1) {
			this.currentRound = {
				Round_Number: -1,
				Year: year
			};
		}
		// pseudo-round for latest round in the newly-selected season - find what that is, and reset the round to that
		else if (roundNo === -2) {
			// retrieve latest round matching the given year
			const maxRound = Math.max(...this.roundOptions.filter(r => r.Year === year).map(r => r.Round_Number));
			const newRound = this.roundOptions.find(r => r.Year === year && r.Round_Number === maxRound);
			this.currentRound = newRound;

			//$scope.getRound(false, newRound.Round_Number, newRound.Year);
		} else if (this.roundOptions.some(r => r.Year === year && r.Round_Number === roundNo)) {
			const newRound = this.roundOptions.find(r => r.Year === year && r.Round_Number === roundNo);
			this.currentRound = newRound;

			//$scope.getRound(false, newRound.Round_Number, newRound.Year);
		}

		// $scope.closeRoundDropdown();
		// $scope.closeYearDropdown();
		this.dateDropdownOpen = false;
		this.roundDropdownOpen = false;
		this.seasonDropdownOpen = false;
		this.tournamentDropdownOpen = false;

		this._$timeout.cancel(this.updateTimeout);

		this.reloadFixtures();
	}

	goToTournament = (tournament: TennisTournament): void => {
		this.currentTournament = tournament;

		this.dateDropdownOpen = false;
		this.roundDropdownOpen = false;
		this.seasonDropdownOpen = false;
		this.tournamentDropdownOpen = false;

		this._$timeout.cancel(this.updateTimeout);

		this.reloadFixtures();
	}

	getTournamentOptions = (resolve: (value?: unknown) => any, reject: (value?: boolean) => any): void => {
		if (!this.roundsLoaded) {
			this.roundsError = false;
			this.sportDataService.getTournamentOptions()
				.then((options) => {
					this.tournamentOptions = options;

					if (this.tournamentOptions.length > 0) {
						if (this.currentTournament === null) {
							let defaultTournamentMatched = false;

							// If a default tournament has been provided in the configuration as "upcoming", make the default tournament the pseudo-tournament that represents all upcoming games
							if (this.configurationObject.defaultTournamentID
								&& this.configurationObject.defaultTournamentID === "upcoming") {
								this.currentTournament = {
									TournamentID: "-1"
								};
								defaultTournamentMatched = true;
							}

							// If a default tournament has been provided in the configuration, and it fits the expected format, look for a tournament that fits it.
							// If one can be found, set that as the starting tournament page. If it can't, or the default tournament is not supplied or invalid...
							else if (this.configurationObject.defaultTournamentID
								&& this.configurationObject.defaultTournamentID.match(/[0-9]+/)) {
								if (this.tournamentOptions.some(t => t.TournamentID === this.configurationObject.defaultTournamentID)) {
									defaultTournamentMatched = true;
									this.currentTournament = this.tournamentOptions.find(t => t.TournamentID === this.configurationObject.defaultTournamentID);
								}
							}


							// ... then search for the tournament with the latest Max Date, and make that the default
							if (!defaultTournamentMatched) {
								this.currentTournament = this.tournamentOptions[0];
							}


						}
						
						resolve();
					} else {
						this.noTournamentsActive = true;
					}

				})
				.catch(reject);
		} else {
			resolve();
		}
	}

	getRoundOptions = (resolve: (value?: unknown) => any, reject: (value?: unknown) => any): void => {
		if (!this.roundsLoaded) {
			this.roundsError = false;
			this.sportDataService.getRoundOptions(this.matchListSport)
				.then((options) => {
					this.roundOptions = options;
					this.seasonOptions = [...new Set(this.roundOptions.map(r => r.Year))].sort();
	
					if (this.currentRound === null) {
						let defaultRoundMatched = false;

						// If a default round has been provided in the configuration as "upcoming", make the default round the pseudo-round that represents all upcoming games
						// (with the latest season available made the corresponding year)

						if (this.configurationObject.defaultRoundID
							&& this.configurationObject.defaultRoundID === "upcoming") {

							this.currentRound = {
								Round_Number: -1,
								Year: this.roundOptions[this.roundOptions.length - 1].Year
							};
							defaultRoundMatched = true;
						}

						// If a default round has been provided in the configuration, and it fits the expected format, look for a round that fits it.
						// If one can be found, set that as the starting round page. If it can't, or the default round is not supplied or invalid...

						else if (this.configurationObject.defaultRoundID
							&& this.configurationObject.defaultRoundID.match(/[0-9]+_[0-9]+/)) {
							
							const [defaultSeason, defaultRound] = this.configurationObject.defaultRoundID.match(/([0-9]+)_([0-9]+)/).slice(1,3);

							if (this.roundOptions.some(r => r.Year === parseInt(defaultSeason) && r.Round_Number === parseInt(defaultRound))) {
								defaultRoundMatched = true;
								this.currentRound = this.roundOptions.find(r => r.Year === parseInt(defaultSeason) && r.Round_Number === parseInt(defaultRound));
							}
						}

						// ... then search for the earliest Active round and make that the default round - and if none are active, 
						// make the last one default.
						if (!defaultRoundMatched) {
							if (this.roundOptions.some(r => r.Active)) {
								this.currentRound = this.roundOptions.filter(r => r.Active)[0];
							} else {
								this.currentRound = this.roundOptions[this.roundOptions.length - 1];
							}
						}
						
						
					}

					$(() => {
		
						$(".datepicker-ctr").datepicker({
							firstDay: 1,
							minDate: new Date(this.roundOptions[0].Round_Date),
							defaultDate: new Date(this.currentRound.Round_Date),
							maxDate: new Date(this.roundOptions[this.roundOptions.length - 1].Round_Date),
							beforeShowDay: (dateToDecide) => {
								const dateString = format(dateToDecide, "yyyy-MM-dd");
								
								return [this.roundOptions.some(r => r.Round_Date === dateString)];
		
							},
							onSelect: (dateSelected) => {
								const dateString = format(parse(dateSelected, "MM/dd/yyyy", new Date()), "yyyy-MM-dd");
								if (this.roundOptions.some(r => r.Round_Date === dateString)) {
									const round = this.roundOptions.find(r => r.Round_Date === dateString);
									//$('.datepicker-ctr').removeClass("visible");
									this.goToRound(round.Year, round.Round_Number);
									this._$scope.$apply();
								}
							}
						});
						// $(".date-dropdown .dropdown-button").click(() => {
						// 	$('.datepicker-ctr').toggleClass("visible");
						// 	vm.dateDropdownOpen = !vm.dateDropdownOpen;
						// });
						
					});
	
	
					resolve();
				})
				.catch(reject);
		} else {
			resolve();
		}
	}

	updateLiveData = (): void => {
		let bookmakerList: Array<string> = [];
		if (this.configurationObject.sportExclusiveBookmakers
			&& Object.keys(this.configurationObject.sportExclusiveBookmakers).includes(this.matchListSport.toUpperCase())) {
			bookmakerList = [this.configurationObject.sportExclusiveBookmakers[this.matchListSport.toUpperCase()]];
		} else if (this.configurationObject.bookmakers) {
			bookmakerList = this.configurationObject.bookmakers;
		} else if (this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme) {
			if (this.configurationObject.bookmakerThemeSportExceptions) {
				bookmakerList = [this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme, "tab"];
			} else {
				bookmakerList = [this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme];
			}
		}
		if ((this.currentRound && this.currentRound.Round_Number === -1) || (this.currentTournament && this.currentTournament.TournamentID === "-1")) {
			this.sportDataService.getUpcomingGames([this.matchListSport.toUpperCase()], true, true, bookmakerList)
				.then(matches => this.processLiveData(matches))
				.catch(() => {
					// TODO better handling of failed live update
				});
		} else if (this.matchListSport.toUpperCase() === "TEN") {
			this.sportDataService.getTournamentMatches(this.currentTournament.TournamentID, true, true, bookmakerList)
				.then(matches => this.processLiveData(matches))
				.catch(() => {
					// TODO better handling of failed live update
				});
		} else {
			this.sportDataService.getRoundMatches(this.matchListSport, this.currentRound.Round_Number, this.currentRound.Year, true, true,
				bookmakerList)
				.then(matches => this.processLiveData(matches))
				.catch(() => {
					// TODO better handling of failed live update
				});
		}
		
	}

	processLiveData = (matches: Array<Match>): void => {
		const existingMatchList: Match[] = this.matches.slice();
		const newMatchList: Match[] = matches;
		
		newMatchList.forEach(match => {
			if (existingMatchList.some(m => m.MatchData.SIMatchID === match.MatchData.SIMatchID)) {
				const oldMatchData = existingMatchList.find(m => m.MatchData.SIMatchID === match.MatchData.SIMatchID);
				if (oldMatchData.LiveData !== match.LiveData) {
					if (oldMatchData.LiveData && match.LiveData) {
						if (oldMatchData.LiveData.homeScore !== match.LiveData.homeScore
							|| oldMatchData.LiveData.homeRuns !== match.LiveData.homeRuns
							|| oldMatchData.LiveData.homeWickets !== match.LiveData.homeWickets) {
							oldMatchData.homeScoreJustChanged = true;
							this._$timeout(() => oldMatchData.homeScoreJustChanged = false, 1000);
						}

						if (oldMatchData.LiveData.awayScore !== match.LiveData.awayScore
							|| oldMatchData.LiveData.awayRuns !== match.LiveData.awayRuns
							|| oldMatchData.LiveData.awayWickets !== match.LiveData.awayWickets) {
							oldMatchData.awayScoreJustChanged = true;
							this._$timeout(() => oldMatchData.awayScoreJustChanged = false, 1000);
						}

					}

					oldMatchData.LiveData = match.LiveData;
				}
			} else {
				match.MatchData.UserDate = parseJSON(match.MatchData.Date);
				this.betService.populateTileBettingInfo(match);
				existingMatchList.push(match);
			}
		});

		existingMatchList.sort((a,b) => this.matchService.gameDisplaySort(a,b));

		this.matches = existingMatchList;

		this.updateTimeout = this._$timeout(this.updateLiveData, 30000);
	}

	retrieveGames = (resolve: (value?: unknown) => any, reject: (value?: unknown) => any): void => {
		this.gamesLoading = true;
		this.gamesError = false;

		let bookmakerList: Array<string> = [];
		if (this.configurationObject.sportExclusiveBookmakers
			&& Object.keys(this.configurationObject.sportExclusiveBookmakers).includes(this.matchListSport.toUpperCase())) {
			bookmakerList = [this.configurationObject.sportExclusiveBookmakers[this.matchListSport.toUpperCase()]];
		} else if (this.configurationObject.bookmakers) {
			bookmakerList = this.configurationObject.bookmakers;
		} else if (this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme) {
			if (this.configurationObject.bookmakerThemeSportExceptions) {
				bookmakerList = [this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme, "tab"];
			} else {
				bookmakerList = [this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme];
			}
		}

		if ((this.currentRound && this.currentRound.Round_Number === -1) || (this.currentTournament && this.currentTournament.TournamentID === "-1")) {
			this.sportDataService.getUpcomingGames([this.matchListSport.toUpperCase()], true, true, bookmakerList)
				.then((matches) => this.processMatches(matches, resolve))
				.catch(reject);
		} else if (this.matchListSport.toUpperCase() === "TEN") {
			this.sportDataService.getTournamentMatches(this.currentTournament.TournamentID, true, true, bookmakerList)
				.then((matches) => this.processMatches(matches, resolve))
				.catch(reject);
		} else {
			this.sportDataService.getRoundMatches(this.matchListSport, this.currentRound.Round_Number, this.currentRound.Year, true, true,
				bookmakerList)
				.then((matches) => this.processMatches(matches, resolve))
				.catch(reject);
		}

		
	}

	processMatches = (matches: Array<Match>, resolve: (value?: any) => void): void => {
		this.matches = matches;

		this.matches.forEach((match: Match) => {
			match.MatchData.UserDate = parseJSON(match.MatchData.Date);
			this.betService.populateTileBettingInfo(match);
			match.homeScoreJustChanged = false;
			match.awayScoreJustChanged = false;
		});

		this.matches.sort((a: Match,b: Match) => this.matchService.gameDisplaySort(a,b));

		this.gamesLoading = false;

		this.updateTimeout = this._$timeout(this.updateLiveData, 30000);

		resolve();
	}
	
	reloadFixtures = (): void => {
		if (this.matchListSport.toUpperCase() === "TEN") {
			new Promise((res,rej) => this.getTournamentOptions(res,rej)).then(() => {
				this._$scope.$apply(() => {
					this.roundsLoaded = true;
				});
				if (!this.noTournamentsActive) {
					new Promise((res,rej) => this.retrieveGames(res,rej)).then(noop, () => {
						this._$scope.$apply(() => {
							this.gamesError = true;
						});
					});
				}
				
			}, () => {
				this._$scope.$apply(() => {
					this.roundsError = true;
				});
			});
		} else {
			new Promise((res,rej) => this.getRoundOptions(res,rej)).then(() => {
				this._$scope.$apply(() => {
					this.roundsLoaded = true;
				});
				new Promise((res,rej) => this.retrieveGames(res,rej)).then(noop, () => {
					this._$scope.$apply(() => {
						this.gamesError = true;
					});
				});
			}, () => {
				this._$scope.$apply(() => {
					this.roundsError = true;
				});
			});
		}
	}
}